import React, { useEffect } from 'react';
import { installMetaPixel } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatWeDo } from './components/WhatWeDo';
import { Products } from './components/Products';
import { Benefits } from './components/Benefits';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Philosophy } from './components/Philosophy';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    installMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="31bianp7oiogh">
      <Header data-id="element-1" data-mp="2wiyy8vkq9zd9" />
      <main data-id="element-2" data-mp="2wj8g1vvmd07v">
        <Hero data-id="element-3" data-mp="2wip54z4dzc3c" />
        <WhatWeDo data-id="element-4" data-mp="2wi5n7ieqknpb" />
        <Products data-id="element-5" data-mp="28u5yeo0zj7dd" />
        <Benefits data-id="element-6" data-mp="28tmfp53igeya" />
        <WhyUs data-id="element-7" data-mp="28t4lsf4bmctj" />
        <Testimonials data-id="element-8" data-mp="28sl3gxardmez" />
        <CTA data-id="element-9" data-mp="28s2ynca15zvg" />
        <Philosophy data-id="element-10" data-mp="23vkvuhy9gblr" />
      </main>
      <Footer data-id="element-11" data-mp="23u9vyt7xrnzx" />
    </div>;
}